// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__L0W+l","content":"Modal_content__qWqHX","content__close":"Modal_content__close__4Lyq0"};